var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-container',[_c('leftTreeRightTable',{ref:"columnTables",attrs:{"title":'数据映射',"zbParams":{
      dwId: 4840,
    },"cbParams":{
      opId:304,
      dataClass : 2,
    },"zbShow":'MODULE_NAME',"zcbGlgx":{
      parProp: 'ID',
      chilProp: 'MODULE_ID'
    },"ljzParams":{
      key: 'PARENT_ID',
      value: 'ID'
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }